module.exports = __webpack_public_path__ + "static/img/case-zlj-page-bg-04.ca62301.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/zlj/case-zlj-page-bg-04.jpg
// module id = tmZG
// module chunks = 1